"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNextTopMarketIdsMapping = exports.setTopMarkets = exports.getMarketIdsMapping = exports.makeMarketComponent = void 0;
var react_1 = __importDefault(require("react"));
var immutable_1 = require("immutable");
var lodash_1 = require("lodash");
function makeMarketComponent(_a) {
    var condition = _a.condition, Component = _a.Component;
    return function Market(markets, commonProps, idx) {
        var suitableMarket;
        var nextMarkets = markets.filter(function (market) {
            if (suitableMarket)
                return true;
            var isSuitable = condition(market);
            if (isSuitable) {
                suitableMarket = market;
            }
            return !isSuitable;
        });
        return {
            nextMarkets: nextMarkets,
            ReactNode: react_1.default.createElement(Component, __assign(__assign({}, commonProps), { key: suitableMarket ? suitableMarket.id : idx, market: suitableMarket })),
        };
        // const suitableMarket: View.Market | undefined = markets.find(market => {
        //     const isSuitable = condition(market);
        //     return isSuitable;
        // });
        // return React.createElement(Component, {
        //     ...commonProps,
        //     key: suitableMarket ? suitableMarket.id : idx,
        //     market: suitableMarket,
        // });
    };
}
exports.makeMarketComponent = makeMarketComponent;
var getMarketIdsMapping = function (topMarketIdsMapping, matches, marketLimit) {
    return lodash_1.reduce(matches, function (resultIdsMapping, match) {
        var topMarketIds = resultIdsMapping.get(match.id);
        var emptyList = topMarketIds ? topMarketIds.clear() : immutable_1.List();
        if (marketLimit && topMarketIds) {
            var restTopMarketIds = topMarketIds.slice(marketLimit);
            return resultIdsMapping.set(match.id, immutable_1.List(match.markets).merge(restTopMarketIds));
        }
        return resultIdsMapping.set(match.id, emptyList.concat(match.markets));
    }, topMarketIdsMapping);
};
exports.getMarketIdsMapping = getMarketIdsMapping;
var setTopMarkets = function (state, action) {
    var topMarketIdsMapping = state.get('topMarketIdsMapping');
    var matches = lodash_1.get(action, 'payload.entities.matches');
    var marketLimit = lodash_1.get(action, 'meta.requestAction.payload.variables.marketLimit');
    if (!matches)
        return state;
    return state.set('topMarketIdsMapping', exports.getMarketIdsMapping(topMarketIdsMapping, matches, marketLimit));
};
exports.setTopMarkets = setTopMarkets;
var getNextTopMarketIdsMapping = function (action, topMarketIdsMapping) {
    var _a = action.payload, isTopMarkets = _a.isTopMarkets, entities = _a.entities;
    if (!isTopMarkets)
        return topMarketIdsMapping;
    var matches = entities === null || entities === void 0 ? void 0 : entities.matches;
    return exports.getMarketIdsMapping(topMarketIdsMapping, matches);
};
exports.getNextTopMarketIdsMapping = getNextTopMarketIdsMapping;
//# sourceMappingURL=utils.js.map